export default __webpack_public_path__ + "static/media/defaultUserIcon.0dbb1760.svg";